// extracted by mini-css-extract-plugin
export default {"update":"UpdateRate_update__v3hO6","boxInput":"UpdateRate_boxInput__YhrYk","boxCur":"UpdateRate_boxCur__MG7lc"};